import { render, staticRenderFns } from "./AppCollapse.vue?vue&type=template&id=43cc5438&"
import script from "./AppCollapse.vue?vue&type=script&lang=js&"
export * from "./AppCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43cc5438')) {
      api.createRecord('43cc5438', component.options)
    } else {
      api.reload('43cc5438', component.options)
    }
    module.hot.accept("./AppCollapse.vue?vue&type=template&id=43cc5438&", function () {
      api.rerender('43cc5438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/app-collapse/AppCollapse.vue"
export default component.exports